import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 80",
  fill: "none",
  preserveAspectRatio: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 -2L20 40L0 82",
      "vector-effect": "non-scaling-stroke",
      stroke: "currentcolor",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }